import { InitialEmailRequestPayload, InitialHttpRequestPayload } from '@/config/app'
import { useState } from 'react'
import { RunCodeRequest } from '@/features/code-runner'

export const useCodeRunnerPayload = (type?: string, initialValue?: any) => {
  const fallbackValue =
    type === 'httpV1' || type === 'httpV2'
      ? InitialHttpRequestPayload
      : type === 'mail'
        ? InitialEmailRequestPayload
        : {}

  return useState(initialValue ?? (fallbackValue as RunCodeRequest['request']))
}
